export function LocationIcon() {
    return (
        <svg
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            width="10.5"
            height="14"
            viewBox="0 0 10.5 14"
        >
            <path
                d="M4.71 13.73a.658.658 0 001.08 0c3.97-5.76 4.71-6.351 4.71-8.468a5.25 5.25 0 00-10.5 0C0 7.379.74 7.97 4.71 13.73zm.54-6.281a2.188 2.188 0 112.19-2.187 2.188 2.188 0 01-2.19 2.187z"
                fill="#67ae3e"
                fillRule="evenodd"
            />
        </svg>
    );
}

export function PhoneIcon() {
    return (
        <svg
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            width="13.97"
            height="13.969"
            viewBox="0 0 13.97 13.969"
        >
            <path
                d="M13.46.654l-2.84-.657a.655.655 0 00-.75.38L8.55 3.44a.658.658 0 00.19.766l1.66 1.356a10.17 10.17 0 01-4.85 4.845L4.2 8.75a.664.664 0 00-.77-.189L.37 9.874a.667.667 0 00-.38.755l.65 2.843a.656.656 0 00.64.509A12.684 12.684 0 0013.97 1.293a.654.654 0 00-.51-.639z"
                fill="#67ae3e"
                fillRule="evenodd"
            />
        </svg>
    );
}

export function SiteIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="7.5" height="12">
            <path
                data-name=""
                d="M7.083 7.726a.43.43 0 00.293-.73L.71.14a.415.415 0 00-.71.3v10.072a.415.415 0 00.71.3l2.031-2.089 1.243 3.026a.414.414 0 00.547.228l1.152-.5a.436.436 0 00.222-.563L4.596 7.727h2.487z"
                fill="#67ae3e"
                fillRule="evenodd"
            />
        </svg>
    );
}

export function EmailIcon() {
    return (
        <svg
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="10.5"
            viewBox="0 0 14 10.5"
        >
            <path
                d="M13.73 3.479c-.61.476-1.42 1.083-4.21 3.109A4.847 4.847 0 017 7.888a4.908 4.908 0 01-2.52-1.3C1.69 4.562.88 3.958.27 3.482A.167.167 0 000 3.61v5.589a1.314 1.314 0 001.31 1.313h11.38A1.314 1.314 0 0014 9.199V3.612a.168.168 0 00-.27-.133zM7 7.012A4.691 4.691 0 009.01 5.88c3.63-2.633 3.9-2.863 4.74-3.519a.65.65 0 00.25-.517v-.52A1.314 1.314 0 0012.69.012H1.31A1.314 1.314 0 000 1.324v.52a.654.654 0 00.25.517c.84.653 1.11.886 4.74 3.519A4.691 4.691 0 007 7.012z"
                fill="#67ae3e"
                fillRule="evenodd"
            />
        </svg>
    );
}

export function WorkHoursIcon() {
    return (
        <svg
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            width="13.56"
            height="13.563"
            viewBox="0 0 13.56 13.563"
        >
            <path
                d="M6.78.013a6.781 6.781 0 106.78 6.781A6.776 6.776 0 006.78.013zm2.53 8.558l-.55.684a.431.431 0 01-.34.164.423.423 0 01-.27-.1L6.32 7.96a1.073 1.073 0 01-.42-.854V2.852a.441.441 0 01.44-.437h.88a.441.441 0 01.44.437V6.79l1.58 1.162a.426.426 0 01.07.619z"
                fill="#67ae3e"
                fillRule="evenodd"
            />
        </svg>
    );
}

export function BreadcrumbSeparatorIcon() {
    return (
        <svg
            className="icon"
            width="12"
            height="18"
            viewBox="0 0 12 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M10 16.37L2 9l8-7.369" stroke="#000" strokeWidth="2" strokeLinecap="square" />
        </svg>
    );
}
